<div class="new-item-modal">
  <h3 class="mat-h3">{{isEditMode ? 'Edit instruction' : 'Add new instruction'}}</h3>
  <form class="form-field-full" [formGroup]="newInstructionForm">
    <div class="form-inputs">
      <mat-form-field class="gingr-input-wrapper w-full">
        <input
          matInput
          placeholder="slug"
          type="text"
          formControlName="slug"
          readonly="{{isEditMode}}"
          required />
        @if (slug.invalid) {
          <mat-error>
            @if (slug.errors?.required) {
              <span>Please enter value
              </span>
            }
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="gingr-input-wrapper w-full">
        <textarea
          matInput
          placeholder="value"
          type="text"
          formControlName="value"
        required></textarea>
        @if (value.invalid) {
          <mat-error>
            @if (value.errors?.required) {
              <span>Please enter value
              </span>
            }
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="gingr-input-wrapper w-full">
        <input
          matInput
          placeholder="Status"
          type="text"
          formControlName="status"
          required />
        @if (status.invalid) {
          <mat-error>
            @if (status.errors?.required) {
              <span>Please enter value
              </span>
            }
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="gingr-input-wrapper w-full">
        <input
          matInput
          placeholder="order"
          type="text"
          formControlName="order"
          required />
        @if (order.invalid) {
          <mat-error>
            @if (order.errors?.required) {
              <span>Please enter value
              </span>
            }
          </mat-error>
        }
      </mat-form-field>

    </div>
    <!--
    <mat-checkbox color="primary" formControlName="rememberMe"
      >{{ 'remember_me' | translate }}
    </mat-checkbox> -->
    <button
      class=""
      mat-raised-button
      color="accent"
      [disabled]="!!newInstructionForm.invalid"
      (click)="save()">
      {{isEditMode ? 'Edit instruction' : 'Add new instruction'}}
    </button>
    <!-- <button class="w-full m-y-16" mat-raised-button color="primary" *ngIf="emailSent">
    {{ 'resend_email' | translate }}
  </button>
  <div class="link-wrapper">
    <a color="primary" routerLink="/">{{ 'back_to_home' | translate }}</a>
  </div> -->
  <!-- <div>
  {{ 'have_no_account' | translate }}?
  <a routerLink="/auth/register">{{ 'create_one_account' | translate }}</a>
</div> -->
</form>
</div>
